<div class="text-xl text-gray-700 font-bold mb-4">Coordenador</div>
<div>
  @if (checkPermission('criar')) {
    <mat-card class="card-style">
      <coordinator-create (responseCreate)="uploadList()" />
    </mat-card>
  }
  <div class="mt-4">
    @if (checkPermission('pesquisar-paginado')) {
      <form-client-search
        [search]="inputSearch"
        [listSearch]="listSearch"
        (responseSearch)="search($event)"
      />
    }
    @if (!loading) {
      <div>
        <table-list-simple
          [dataSource]="itemsList"
          [columns]="columns"
          (selectItem)="editItem($event)"
          (deleteItem)="deleteItem($event)"
          (activeItem)="activeItem($event)"
        />
        @if (itemsList.length > 0) {
          <mat-paginator
            [length]="numberRows"
            [pageSize]="rows"
            [pageIndex]="page - 1"
            [pageSizeOptions]="[5, 10, 20, 30]"
            (page)="onPageEvent($event)"
          >
          </mat-paginator>
        }
      </div>
    } @else {
      <div>
        <mat-progress-bar mode="indeterminate"></mat-progress-bar>
      </div>
    }
  </div>
</div>
